import { useEffect, useRef } from 'react';
import { Nullable } from '~globals/types';

export type UseIntervalCallback = () => void;

export const useInterval = (
  callback: UseIntervalCallback,
  delay: Nullable<number>,
): void => {
  const savedCallback = useRef<UseIntervalCallback>(() => {});

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    if (delay !== null) {
      const interval = setInterval(() => savedCallback.current(), delay || 0);

      return () => clearInterval(interval);
    }

    return undefined;
  }, [delay]);
};
